import React, { useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import LoadingSpinner from 'src/components/shared/loadingSpinner/loadingSpinner';
import { TOAST_TIMEOUT } from 'src/config/Toast';
import { getAccommodationQueryOptions } from 'src/services/accommodation/accommodationQueries';
import { useAppDispatch } from 'src/store/store';
import { createToast } from 'src/store/toastsSlice';
import { isValidNumber } from 'src/utils/helpers';
import { CaseSources } from 'src/utils/jmrUtils';

/**
 * Default component.
 */
const PlacementDetailsRedirect = () => {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { type, caseId, login } = useParams();
  const {
    data: placementId,
    isSuccess,
    isError,
  } = useQuery({
    ...getAccommodationQueryOptions.accommodationIdByCaseIdAndLogin(type, caseId, login),
    meta: { skipErrorToast: true },
  });

  const redirctToWizard = () => {
    dispatch(
      createToast({
        type: 'success',
        message: 'An RTW placement cannot be found for the selected AUSTIN Case. Please create one below...',
        timeout: TOAST_TIMEOUT,
      }),
    );
    navigate(`/newJmr/${CaseSources.Austin}/${login}/${caseId}`);
  };

  const redirectToDetails = (placementId: number) => {
    dispatch(
      createToast({
        type: 'success',
        message: 'Existing RTW placement found, redirecting to the Placement Details page...',
        timeout: TOAST_TIMEOUT,
      }),
    );
    queryClient.invalidateQueries({
      queryKey: getAccommodationQueryOptions.accommodationDetails(placementId).queryKey,
    });
    navigate(`/placementDetails/${placementId}`, { replace: true });
  };

  // Show toasts if redirect URL changes
  useEffect(() => {
    if (isSuccess) {
      if (isValidNumber(placementId)) {
        redirectToDetails(placementId);
      } else {
        redirctToWizard();
      }
    }

    if (isError) {
      redirctToWizard();
    }
  }, [isSuccess, isError, placementId]);

  return <LoadingSpinner />;
};

export default PlacementDetailsRedirect;
